module.exports = __webpack_public_path__ + "img/voorkeur.6b19bd4b.jpg";